import React from 'react';

function EAccountCard({ account, onEdit, onDelete, t }) {
  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(account);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(account);
  };

  const titleText = account.titleIsKey ? t(account.title) : (account.title || account.name || account.email_name || account.subscription_for);
  const descriptionText = account.description || (account.descriptionKey ? t(account.descriptionKey) : '');
  const whoHasText = account.who_has || account.whoHas || (account.whoHasKey ? t(account.whoHasKey) : '');

  return (
    <div className="e-account-card">
      <div className="e-account-card-header">
        <h3 className="e-account-card-title">{titleText}</h3>
      </div>
      
      <div className="e-account-card-body">
        <div className="e-account-fields-group">
          {account.fields.map((field, idx) => (
            <div key={idx} className="e-account-card-field">
              {field.label && field.value ? (
                <>
                  <span style={{ color: '#64748b', fontSize: '13px' }}>{field.label}: </span>
                  <span style={{ fontWeight: '500' }}>{field.value}</span>
                </>
              ) : field.text ? (
                field.text
              ) : (
                t(field.key)
              )}
            </div>
          ))}
        </div>
        
        {descriptionText && (
          <div className="e-account-card-description">
            {descriptionText}
          </div>
        )}
      </div>

      <div className="e-account-card-footer">
        <span className="e-account-who-has">
          {whoHasText ? (
            whoHasText.startsWith('Who Has') || whoHasText.startsWith('eAccounts.') ? whoHasText : `Who Has: ${whoHasText}`
          ) : 'Who Has: —'}
        </span>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          {onEdit && (
            <button 
              type="button" 
              className="e-account-edit-btn" 
              onClick={handleEditClick}
            >
              Edit
            </button>
          )}
          {onDelete && (
            <button 
              type="button" 
              className="e-account-delete-btn" 
              onClick={handleDeleteClick}
              style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default EAccountCard;
